import { render, staticRenderFns } from "./StickyHeader.vue?vue&type=template&id=11080996&scoped=true&"
import script from "./StickyHeader.vue?vue&type=script&lang=js&"
export * from "./StickyHeader.vue?vue&type=script&lang=js&"
import style0 from "./StickyHeader.vue?vue&type=style&index=0&id=11080996&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11080996",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/induline.salamander.live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11080996')) {
      api.createRecord('11080996', component.options)
    } else {
      api.reload('11080996', component.options)
    }
    module.hot.accept("./StickyHeader.vue?vue&type=template&id=11080996&scoped=true&", function () {
      api.rerender('11080996', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/ui/StickyHeader.vue"
export default component.exports